module.exports = __webpack_public_path__ + "static/media/programmer.a34154e9.svg";